module.exports = __webpack_public_path__ + "static/Oya_43-f19003a3f21899d66d0bd5f4d042eb51.jpg";